exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-QuestionStatus {\n  margin: 10px 20px 0;\n  font-size: 13px;\n  text-align: right;\n  color: #888;\n}\n.cs-QuestionStatus__last-update {\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/QuestionStatus/QuestionStatus.less
// module id = 901
// module chunks = 0